import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { CoManageDataAccessObject } from '@safarilaw-webapp/feature/co-manage/data-access';
import { CustomThemeIds } from '@safarilaw-webapp/feature/rms/data-access';

import { NavbarPermissionsService } from '@safarilaw-webapp/shared/app-bootstrap/data-access';
import { AuthService, PermissionsService } from '@safarilaw-webapp/shared/auth/store-access';

import { AppConfigurationService, FeatureFlagsService } from '@safarilaw-webapp/shared/environment';

@Injectable({
  providedIn: 'root'
})
export class RmsNavbarPermissionsService extends NavbarPermissionsService {
  constructor(
    userPermissionService: PermissionsService,
    actions: Actions,
    store: Store<any>,
    featureFlags: FeatureFlagsService,
    authService: AuthService,
    appConfig: AppConfigurationService,
    coManageObject: CoManageDataAccessObject
  ) {
    super(userPermissionService, actions, store, featureFlags, authService, appConfig, coManageObject);
  }

  get customThemeId(): string {
    if (this.isPlatformBrowser) {
      return window['Safari']?.customThemeId as string;
    }
    return null;
  }

  isCustomPortal(): boolean {
    return !!this.customThemeId;
  }
  isAgencyPortal(): boolean {
    return this.customThemeId == CustomThemeIds.agency;
  }
  isCustomClientPortal(): boolean {
    return !!this.customThemeId && this.customThemeId !== CustomThemeIds.agency;
  }
}
